module.exports = __webpack_public_path__ + "media/speakers/conference@3x-cf7b4570.png";